import React from "react";
import { Paper, Typography, Box } from "@material-ui/core";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import PageTitle from "../global/PageTitle/PageTitle";
import "./Expensepage.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Expense from "./Expense";
export default function Expensepage() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <div class="Expensepage">
        <PageTitle title="Expenses" back />
        <div className="Expense-main">
          <div className="Expense-box1">
            <Paper className="Expense-box1-item1">
              <Typography>Change</Typography>
              <div className="Expense-item1">
                <Box className="Expense-box">
                  <Link
                    to="#"
                    className="Expense-link"
                    onClick={handleClickOpen}
                  >
                    Create Expense Report
                  </Link>
                </Box>
                <Dialog 
                    open={open} 
                    onClose={handleClose}
                    fullWidth
                    maxWidth="lg"
                >
                  <DialogContent fullWidth>
                    <Expense />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                  </DialogActions>
                </Dialog>

                <Box className="Expense-box">
                  <Link to="#" className="Expense-link">
                    Edit Expense Transactions
                  </Link>
                </Box>
              </div>
            </Paper>
            <Paper className="Expense-box1-item2">
              <Typography>View</Typography>
              <div className="Expense-item2">
                <Box className="Expense-box">
                  <Link to="#" className="Expense-link">
                    Travel & Expense Links
                  </Link>
                </Box>
                <Box className="Expense-box">
                  <Link to="#" className="Expense-link">
                    Expense Reports
                  </Link>
                </Box>
                <Box className="Expense-box">
                  <Link to="#" className="Expense-link">
                    Expense Transactions
                  </Link>
                </Box>
                <Box className="Expense-box">
                  <Link to="#" className="Expense-link">
                    Payment Elections
                  </Link>
                </Box>
              </div>
            </Paper>
          </div>
          <div className="Expense-box2">
            <Paper className="Expense-box1-item1" style={{ height: "150px" }}>
              <Typography>Recent Expense Reports</Typography>

              <Box className="Expense-box">
                <Link to="#" className="Expense-link">
                  Draft- 03/22/2022 - memo
                </Link>
              </Box>
              <Box className="Expense-box">
                <Link to="#" className="Expense-link">
                  Draft- 03/22/2022 - memo
                </Link>
              </Box>
              <Box className="Expense-box">
                <Link to="#" className="Expense-link">
                  Draft- 03/22/2022 - memo
                </Link>
              </Box>
            </Paper>
          </div>
        </div>
      </div>
    </>
  );
}
